import { render, staticRenderFns } from "./IntegrationsButton.vue?vue&type=template&id=25600aa4&"
import script from "./IntegrationsButton.vue?vue&type=script&lang=js&"
export * from "./IntegrationsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports